import React from 'react'
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import axios from 'axios'
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Chip from '@material-ui/core/Chip';
import AdbIcon from '@material-ui/icons/Adb';
import { Button, CircularProgress }  from '@material-ui/core';
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
// import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/AddCircle';
// import FilterListIcon from '@material-ui/icons/FilterList';
import moment from 'moment'
import { Link } from 'react-router-dom'
// import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { socket } from '../SocketIo/Socket'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ChooseEntityComponent from '../Entities/ChooseEntityComponent'

function desc(a, b, orderBy, isDate) {
  // console.log('desc: ', a)
  // console.log('desc b: ', b)
  if (isDate) {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      // console.log('B is < A')
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      // console.log('B is > A')
      return 1;
    }
    // console.log('B is ? A')
    // console.log('A: ', a[orderBy])
    // console.log('B: ', b[orderBy])
    return 0;
  } else {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      return 1;
    }
    return 0;
  }
}

function stableSort(array, cmp) {
  // console.log('Stable sort: ', array.length)
  // console.log('CMP: ', cmp)
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  // console.log('Matches: ', stabilizedThis.length)
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  if (orderBy==='lastUpdated') {
  // console.log('Last Updated')
    return order === 'desc' ? (a, b) => desc(a, b, orderBy, true) : (a, b) => -desc(a, b, orderBy, true);
  } else {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }
  
}

const headCells = [
  { id: 'type', numeric: false, disablePadding: true, label: 'Type' },
  { id: 'notes', numeric: false, disablePadding: false, label: 'Notes' },
  { id: 'created_at', numeric: false, disablePadding: false, label: 'Created' },
  { id: 'user', numeric: false, disablePadding: false, label: 'Created By' },
  { id: 'details', numeric: false, disablePadding: false, label: 'Details' },
  { id: 'action', numeric: false, disablePadding: false, label: 'Action' }
];

function EnhancedTableHead(props) {
// console.log('Got our props', props)
  
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
  // console.log('Sort Property: ', property)
  // console.log('sort event; ', event)
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all leads' }}
          />
        </TableCell> */}
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    margin: 10
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fakeLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue'
  }
}));

function EnhancedTable(props) {
// console.log('Customer  Issues Props: ', props)
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('-created');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [searchValue, setsearchValue] = React.useState('');
  const [searchMatches, setsearchMatches] = React.useState(0);
  const [issueDetailsModalOpen, setIssueDetailsModalOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [rows, setRows] = React.useState([])
  const [filteredRows, setFilteredRows] = React.useState([])
  const [state, setState] = React.useState({
    searchMatches: 0,
    lastUpdate: null
  })

  React.useEffect(() => {
    const socketName = 'fieldUpdates'
    let isMounted = true
  // console.log('Use effectset customer issue list: ', props.clients)
    fetchData(false, null, 'All')

    socket.on(socketName, (data) => {
      dealWithSocketUpdates(data)
    })

    return () => {
      isMounted = false
      socket.off(socketName)
    }
  }, [])

  const fetchData = async (toReturn, startInterval, entityToUse) => {
    // console.log('Fetch our customer issues')
    // console.log('Fetch Data called!!', state)
      setLoading(true)
      const response = await axios.get(`${props.url}/api/company/getFieldUpdates?entity=${entityToUse}`)
    // console.log(response)
      if (response.data && response.data.length > 0) {
        setLoading(false)
        // console.log('Got Field Updates', response.data)
        if (toReturn) {
          return response.data
        } else {
          setRows(response.data || [])
          setFilteredRows(response.data || [])
          setState(prevState => ({ ...prevState, lastUpdate: new Date() }))
          // if (startInterval) {
          //   setTimeout(() => {
          //     fetchData(true)
          //   }, 95000)
          // }
        }
      } else {
      // console.log('Fucked up')
      }
    }

  const dealWithSocketUpdates = React.useCallback((data) => {
  
    console.log('Socket update ', data)
    if (data && data.type === 'workComplete' && data.wo) {
      let wo = {
        jobName: '',
        number: ''
      }
      if (data.wo && data.wo._id) wo = data.wo
      let emp = {
        displayName: 'Someone'
      }
      if (data.emp) {
        emp = data.emp
      }
      if (wo && wo._id) {
        // let newRows = []
        console.log('Gotta build an issue here...', wo)
        let createdBy = emp.displayName
        let details = {
          jobName: wo.jobName,
          jobNumber: wo.jobNumber,
          woNumber: wo.number
        }
        let theLine = {
          type: 'Work Completed',
          details: details,
          created_at: wo.work_complete_at,
          created_by: createdBy,
          _id: wo._id
        }
        console.log('The line:', theLine)
        console.log("Rows right now...", rows)
        console.log('Filteredrows', filteredRows)
        let newLines = [ theLine, ...rows ]
        console.log("New Lines", newLines)
        setRows(currentRows => [theLine, ...currentRows]);
        if (searchValue === '') {
          setFilteredRows(currentRows => [theLine, ...currentRows]);
        } else {
          filterOut(newLines, searchValue)
        }
      }
      // Add WOrkorder Complete to the top of the LIST!!
      props.notification({
        type: 'success',
        title: 'Workorder Completed!',
        message: `${emp.displayName} just completed Workorder #${wo.number} (${wo.jobName})`
      })
    }
  }, [rows])


  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
  // console.log('Set order by property: ' + property + ' in ' + isDesc + ' order')
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n._id);
      // console.log(newSelecteds)
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // const handleClick = (event, name) => {
  //   const selectedIndex = selected.indexOf(name);
  // // console.log('handle click ', name)
  // // console.log('Index: ', selectedIndex)
  //   let newSelected = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, name);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selected.slice(0, selectedIndex),
  //       selected.slice(selectedIndex + 1),
  //     );
  //   }

  //   setSelected(newSelected);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const storeSearchMatches = (d) => {
  // console.log('Search matches: ', d)
    // setState({...state, searchMatches: d.length})
  }
  // const handleChangeDense = event => {
  //   setDense(event.target.checked);
  // };

  const isSelected = name => selected.indexOf(name) !== -1;

  const emptyRows = 0// rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const filterOut = (r, searchText) => {
  // console.log('FIlter out: %s - %s', r, searchText)
    let string = searchText
    let newArr = []
    r.filter(o => {
      // console.log('Object:  ', o)
      Object.keys(o).some(k => {
        // console.log(o[k])
        if(o[k]) {
          // console.log('OK: ', o[k])
          let str = o[k].toString().toLowerCase() 
          // console.log(str)
          if (str.includes(string.toLowerCase())) {
            // console.log('Mathc')
            return newArr.push(o)
          } else {
            return null
          }
        } else {
          return null
        }
      })
      // return newArr
    })

    setFilteredRows(newArr)
  }

  const handleChange = (name) => (event) => {
  // console.log('Searching: ', event.target.value)
    setsearchValue(event.target.value)
    if (event.target.value === '') {
      setFilteredRows(rows)
    } else {
      filterOut(rows, event.target.value)
    }
    setPage(0)
  }


const PhotoLine = (props) => {
  let photos = props.photos
  return (
    <>
      { photos.map((item, index) => {
        if (item.uri) {
          const containHTTPS = item.uri.includes('https://')
          const uri = containHTTPS ? item.uri : 'https://' + item.uri
          return (
            <img key={index} style={{margin: 5, borderRadius: 15}} src={uri} width="140" />
          )
        } else {
          return (
            'Invalid URI'
          )
        }
      })}

    </>
  )
}

const handleUpdateVisibleEntity = (newEntity) => {
  // console.log('New entity', newEntity)
    fetchData(false, null, newEntity._id)
  }

const PhotosDisplay = (props) => {
  let item = props.item
  if (item && item.photos && item.photos.length) {
    return <PhotoLine photos={item.photos} />
  } else {
    return ''
  }
}

  return (
    <div className={classes.root}>
     
      {/* <IssueDetailsModal open={issueDetailsModalOpen} service={svc} updateParent={updateFromSvcModal} /> */}
     <Paper className={classes.paper}>
     
       <h2>Updates from The Field</h2>
        <Grid container style={{padding: '10px'}}>
          <Grid item lg={12} xs={12} md={12} sm={12}>
            <ChooseEntityComponent allowAll={true} title={'Visible Entities'} user={props.user} updateParent={handleUpdateVisibleEntity} />
          </Grid>
          <Grid item lg={3} xs={6}>
          Total Updates: {filteredRows.length}
          </Grid>
          <Grid item lg={3} xs={6}>
            {
              state.lastUpdate ? (
                `Last Updated: ${  moment(state.lastUpdate).fromNow()}`
              ) : null
            } 
          </Grid>
        </Grid>
        <Grid container style={{padding: '10px'}}>
          <Grid item lg={6} xs={6}>

            <div className={classes.search}>
                <div >
                  <SearchIcon /> Search { searchValue ? filteredRows.length > 1 ? `(${filteredRows.length} Matches)` : `(${filteredRows.length} Match)` : ''}
                </div>
                <input name="search" value={ searchValue } onChange={ handleChange('search') } type="text"></input>
              </div>
          </Grid>
          <Grid item lg={6} xs={6}>
            
          </Grid>
        </Grid>
        <div className={classes.tableWrapper} style={{margin: '10px'}}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              { stableSort(filteredRows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // console.log('Row map: ', row)
                  // console.log('Total rows; ', rows)
                  const isItemSelected = isSelected(row._id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  // setsearchMatches(rows.length)
                  // console.log(row)
                  return (
                    
                    <TableRow
                      hover
                      // onClick={event => handleClick(event, row._id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                      style={row.pastDue ? { backgroundColor: 'rgba(233, 103, 103, .5)', } : null}
                    >
                              
                      <TableCell align="left">{ row.type } </TableCell>
                      <TableCell align="left">
                        {
                          row.type === 'Work Completed' ? (
                             JSON.stringify(row.notes)
                          ) : row.notes 
                        }
                        {
                          row.type === 'Workorder Photo' ? <Notes data={row} /> : '' 
                        }
                      </TableCell>
                      <TableCell align="left">{ row.created_at ? moment(row.created_at).format('MM/DD/YYYY - hh:mmA') : '' }</TableCell>
                      <TableCell align="left">{ row.created_by ? row.created_by : '' }</TableCell>
                      <TableCell align="left">{row.notes ? row.notes : ''}<DetailsAndShit data={row} /></TableCell>
                    </TableRow>
                  );
                })
              }
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          { loading ?<CircularProgress style={{color: '#fff'}} size={ 16 } /> : ''}
                    
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </div>
  );
}

const Notes = ({ data }) => {
  let details = data.details
  return (
    <div>
      Job Name: {details.jobName} #{details.jobNumber} - Workorder #{details.woNumber}
    </div>
  )  
}

const DetailsAndShit = ({ data }) => {
  // console.log('Details:', data)
  if (data && data.details && data.details.url) {
    let url = data.details.url
    if (url && !url.includes('https')) {
      url = `https://${url}`
    }
    return (
      <div>
        <img src={url} height={150} />
      </div>
    )
  } else if (data && data.details && data.details.uploads && data.details.uploads.length) {
    return <UploadsDetailsList uploads={data.details.uploads} />
  } else if (data.type && data.type === 'Work Completed' || data.type === 'Workorder Photo') {
    let details = data.details
    // console.log('Show the details', details)
    if (details.client && details.client.length) {
      return (
        <div>
           Job Name: <Link
            to={{
              pathname: `/clients/${details.client}/Job/${details.jobId}`
            }}
            style={{pointer: 'cursor'}}
            target="_blank"
            >
               {details.jobName} #{details.jobNumber}
            </Link> - Workorder #{details.woNumber}
        </div>
      ) 
    } else {
      return (
        <div>
          Job Name: {details.jobName} #{details.jobNumber} - Workorder #{details.woNumber}
        </div>
      ) 
    }
 
  } else {
    return null
  }
}

const UploadsDetailsList = ({ uploads }) => {

  return (
    <div>
      {
        uploads.map(upload => {
          return <UploadDetails upload={upload} key={upload._id} />
        })
      }
    </div>
    
  )
}

const UploadDetails = ({ upload }) => {
  let url = upload.url
  if (url && !url.includes('https')) {
    url = `https://${url}`
  }
  return (
    <div>
       {
         url.includes('.mp4') ? <AudioItem url={url} /> :  <img src={url} height={150} />
       }
    </div>
  )
}

const AudioItem = ({ url }) => {
  return (
    <audio controls>
        <source src={url} type="audio/mp4" />
        Your browser does not support the audio element.
    </audio>
  )
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url
  }
}

export default connect(mapStateToProps)(EnhancedTable)

